/*** IMPORTS FROM imports-loader ***/
var define = false;

import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
	mode: 'history',
	routes: [
	{ 
		path: '/',
		name: 'login',
		component: require('./components/LoginView.vue')
	},
	{
		path: '/app/:appId/floorplan/',
		name: 'floorplan',
		component: require('./components/floorplan.vue')
	},
	{
		path: '/admin/',
		name: 'admin',
		component: require('./components/Admin/AdminView.vue'),
		children: [
		{ 
			path: '',
			name: 'admin-notifications',
			component: require('./components/Admin/Notifications.vue')
		},
		{ 
			path: 'answers',
			name: 'admin-answers',
			component: require('./components/Admin/Answers.vue')
		},
		{ 
			path: 'presentations',
			name: 'admin-presentations',
			component: require('./components/Admin/PresentationsView.vue')
		},
		{ 
			path: 'lecturers',
			name: 'admin-lecturers',
			component: require('./components/Admin/LecturersView.vue')
		},
		{
			path: 'information',
			name: 'admin-information',
			component: require('./components/Admin/InformationView.vue')
		},
		{
			path: 'editor',
			name: 'admin-editor',
			component: require('./components/Admin/EditorView.vue')
		}
		]
	}
	]
})



// WEBPACK FOOTER //
// ./src/router.js